import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorLeftPaneStyles: IStyles = {
    pane: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flexShrink: 0,
    },
    paneFixed: {
        flexGrow: 0,
        flexShrink: 0,
        overflow: 'hidden',
    },
    paneCatalog: {
        flex: '1 1 0%',
        minHeight: 120,
        overflow: 'hidden',
    },
    paneCollapsed: {
        flex: '0 0 auto !important',
        height: 'auto !important',
        maxHeight: 'none !important',
        minHeight: '0 !important',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 10px',
        minHeight: 46,
        boxSizing: 'border-box',
        borderBottom: `1px solid ${color.blue100}`,
        flexShrink: 0,
        background: color.blue100,
        userSelect: 'none',
    },
    toggle: {
        width: 30,
        height: 30,
        border: `1px solid ${color.borderDarkPrimary}`,
        background: color.bgWhitePrimary,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
        flexShrink: 0,
        padding: 0,
        margin: 0,
        lineHeight: 0,
        boxSizing: 'border-box',
    },
    toggleCollapsed: {
        transform: 'rotate(-90deg)',
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: color.fontDarkUltraHigh,
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '30px',

        '&::before': {
            content: '""',
            width: 3,
            height: 11,
            borderRadius: 2,
            background: color.blue400,
            flexShrink: 0,
        },
    },
    headerAction: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        height: 30,
        alignSelf: 'center',
    },
    headerActionButton: {
        width: 30,
        height: 30,
        border: `1px solid ${color.borderDarkPrimary}`,
        background: color.bgWhitePrimary,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
        padding: 0,
        margin: 0,
        lineHeight: 0,
        boxSizing: 'border-box',
        color: color.fontDarkUltraHigh,
        appearance: 'none',
        WebkitAppearance: 'none',

        '&:hover': {
            borderColor: color.blue400,
            color: color.blue,
        },
    },
    body: {
        flex: '1 1 0%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    splitter: {
        flex: '0 0 6px',
        cursor: 'row-resize',
        background: color.bgWhiteSecondary,
        borderTop: `1px solid ${color.borderDarkPrimary}`,
        borderBottom: `1px solid ${color.borderDarkPrimary}`,
        position: 'relative',
        zIndex: 2,
        touchAction: 'none',
        userSelect: 'none',

        '&:hover': {
            background: color.blue100,
        },
    },
    splitterActive: {
        background: color.blue200,
    },
    splitterDisabled: {
        cursor: 'default',
        pointerEvents: 'none',
        opacity: 0.45,
    },
}

addStyles(templateEditorLeftPaneStyles)
export default templateEditorLeftPaneStyles
